import * as React from 'react';
import classNames from 'classnames';
import {BREAKPOINTS} from 'utilities/breakpoints';
import {ImageOptions, Picture} from 'components/UIKit/Picture';
import {NOOP} from '../utilities';
import styles from './Card.scss';

type DivElementProps = JSX.IntrinsicElements['div'];

export interface CardProps extends DivElementProps {
  contentClassName?: string;
  className?: string;
  component?: string | React.ComponentClass;
  imageUrl?: string;
  imageAlt?: string;
  children: React.ReactNode;
  onClick?: React.MouseEventHandler;
}

const imageOptions: ImageOptions[] = [
  {
    breakpoint: BREAKPOINTS.mobile,
    fallback: true,
    options: {
      width: 364,
      height: 240,
    },
  },
  {
    breakpoint: BREAKPOINTS.tablet,
    options: {
      width: 442,
      height: 240,
    },
  },
  {
    breakpoint: BREAKPOINTS.desktopUp,
    options: {
      width: 336,
      height: 240,
    },
  },
];

export function Card({
  contentClassName,
  className,
  component = 'div',
  imageUrl,
  imageAlt,
  children,
  onClick = NOOP,
  ...restProps
}: CardProps) {
  const Wrapper = component;

  return (
    <Wrapper className={classNames(styles.card, className)} onClick={onClick} {...restProps}>
      {imageUrl && (
        <Picture
          pictureClassName={styles.image}
          imageUrl={imageUrl}
          imageOptions={imageOptions}
          alt={imageAlt || ''}
          lazyload
        />
      )}
      <div
        className={classNames(styles.cardContent, contentClassName, {
          [styles.noBorderTop]: imageUrl,
        })}
      >
        {children}
      </div>
    </Wrapper>
  );
}
